// extracted by mini-css-extract-plugin
module.exports =  {"btn":"a867bdd7c0--btn--z4lyl","phone":"a867bdd7c0--phone--O56kL"};